import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {Spinner} from "react-bootstrap";

class DmxPxmSceneForm extends Component {

    state = {
        form: {
            id: null,
            networkDeviceId: null,
            label: null,
            registryAddress: "",
            value: "",
            isActive: false,
            turnOnScene: false,
        },
        isEdit: false
    };

    componentDidMount() {
        if(!this.props.data) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    networkDeviceId: this.props.networkDeviceId,
                    turnOnScene: null,
                    isActive: false
                },
                isEdit: false
            });
        }

        if(this.props.data) {
            const { data } = this.props;
            this.setState({
                ...this.state,
                isEdit: true,
                form: {
                    id: data.id,
                    label: data.label,
                    networkDeviceId: data.networkDeviceId,
                    turnOnScene: data.turnOnScene ? data.turnOnScene.toString() : "null",
                    registryAddress: data.registryAddress,
                    value: data.value,
                    isActive: data.isActive,
                }
            })
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    handleSelect = (e) => {
        e.preventDefault();
        const value = e.target.value;
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name] : value,
            }
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        let localState = null;
        if(this.state.form.turnOnScene === "true") {
            localState = true
        } else if(this.state.form.turnOnScene === "false") {
            localState = false;
        }

        this.state.form.turnOnScene = localState;
        this.props.submitForm(this.state.form);
    };

    render() {
        const { t } = this.props;
        const { form } = this.state;


        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label className="col-form-label">{t('modbus-registry-address')}</label>
                        <input
                            className="form-control"
                            type="number"
                            name="registryAddress"
                            title="registryAddress"
                            value={!isNaN(form?.registryAddress) ? form.registryAddress : 0}
                            onChange={this.handleOnChangeInput}
                            required
                        />

                    </div>
                    <div className={"form-group "}>
                        <label className="col-form-label">{t('modbus-value')}</label>
                        <input
                            className={`form-control`}
                            type="number"
                            name="value"
                            title="value"
                            value={!isNaN(form?.value) || form.value !== null ? form.value : ""}
                            onChange={this.handleOnChangeInput}
                            required
                        />

                    </div>
                    <div className="form-group">
                        <label className="col-form-label">{t('label')}</label>
                        <input
                            className="form-control"
                            name="label"
                            title="label"
                            value={form.label || ''}
                            onChange={this.handleOnChangeInput}
                        />
                    </div>
                    <div className="form-group">
                        <label className="col-form-label">{t('action')}</label>
                        <select
                            className="form-control"
                            name="turnOnScene"
                            value={form.turnOnScene || ''}
                            onChange={this.handleSelect}
                        >
                            <option value={"null"}>{t('additional')}</option>
                            <option value={"true"}>{t('exhibition-on')}</option>
                            <option value={"false"}>{t('exhibition-off')}</option>
                        </select>
                    </div>

                    <div className="form-group float-right">
                        { this.state.isEdit ? (
                            <button type="submit" className={"btn btn-primary" }>
                                <i className="fas fa-edit"> </i> {t('edit')}
                            </button>
                        ) : (
                            <button type="submit" className={"btn btn-success" }>
                                <i className="fas fa-plus"> </i> {t('create')}
                            </button>
                        ) }
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { validationForm } = state.daliHelvarReducer;
    return {
    }
};
export default withNamespaces()(connect(mapStateToProps)(DmxPxmSceneForm));
